/** @name RCDPW.validator.rules.signUp.questionnaire */
RCDPW.module('RCDPW.validator.rules.signUp.questionnaire', {
    applicationName: 'required',
    applicationDescription: 'required',
    applicationTypes: 'required',
    useCases: 'required',
    mainNumber: 'required',
    userName: 'required',
    company: 'required',
    Other: {
        required: {
            depends: function () {
                return !!$('.use-case-others input:checked').prop('checked');
            }
        }
    }
});